<template>
	<div class="h-panel-body padding font-bold">
		<div class="h-panel-bar"><span class="h-panel-title">生活服务人员</span></div>
		<div class="topselectbox">

			<div class="topselect01">
				<div class="waitselect" style="width: 230px;display:flex;">
					<span>服务人员：</span>
					<Select v-model="waiterSelect" class="bmselect" @change="selectWaiter" :datas="waiterList"></Select>
				</div>
                <div class="waitselect" style="width: 240px;display:flex;">
					<span style="width:90px;">所属商家：</span>
					<Select v-model="storeSelect" class="bmselect" @change="selectStore" :datas="storeList"></Select>
				</div>

				<div class="waitselect"><button class="h-btn h-btn-blue" @click="selectmsg">查询</button> </div>

			</div>

			<div class="topselect02">

				<div>
					<button class="h-btn">导出</button>
				</div>

			</div>


		</div>

		<div class="emtablebox">
            
            <Table :datas="datas" :height="400" :border="true">
                <TableItem title="姓名" prop="name" :width="150"  />
                <TableItem title="性别" align="center" :width="100" >
                    <template #default="{ data }">
                        <span style=" margin-right:10px; " v-if="data.sex">男</span>
                        <span style=" margin-right:10px; " v-else>女</span>
                    </template>
                </TableItem>
                <TableItem title="头像"  align="center" :width="150" >
                    <template #default="{ data }">
                        <img style="width:50px;height:50px"  :src="data.avatar"/>
                    </template>
                </TableItem>
                <TableItem title="绑定微信号" align="center" prop="wechat" :width="150" />
                <TableItem title="所属商家" prop="businessesName" align="center" :width="150" />
                <TableItem title="所属店铺" prop="storeName" align="center" :width="150" />
                <TableItem title="联系号码" prop="phone" align="center" :width="150" />
                <TableItem title="总单数" prop="orderCnt" align="center" :width="80" />
                <TableItem title="状态" align="center" :width="90">
                    <template #default="{ data }">
                        <span style="color:green;cursor: pointer;" v-if="data.state == '1'">开启</span>
                        <span style="color:red;cursor: pointer;" v-else>关闭</span>
                    </template>
                </TableItem>
                <TableItem title="总佣金" prop="rebateAmount" align="center" :width="80" />
                <TableItem title="可提现余额" prop="salaryAmount" align="center" :width="80" >
                    <template #default="{ data }">
                        {{ data.rebateAmount - data.cashoutAmount }}
                    </template>
                </TableItem>
                <TableItem title="查看" :width="100" align="center" fixed="right">
                    <template #default="{ data }">
                        <span style="color:blue;margin-right:10px;cursor: pointer;" @click="showDrawer(data)">查看订单</span>
                    </template>
                </TableItem>
                <template #empty>
                    自定义提醒：暂时无数据
                </template>
            </Table>


		</div>
        <Modal v-model="showOrder" class="md_showOrder" hasCloseIcon>
			    <div slot="header">订单列表</div>
                <div class="topselectbox">
                    <div class="topselect01">
                        <div class="waitselect2"  style="width: 230px;display:flex;float: left;"> 
                            <a-range-picker :locale="locale"  @change="onLocalChange" />
                        </div>
                        
                        <div class="waitselect" style="width: 230px;display:flex;">
                            <span>服务人员：</span>
                            <Select v-model="waiterOrderQueryObj.waiterOrderSelect" class="bmselect" @change="selectWaiter2" :datas="waiterList2"></Select>
                        </div>
                        <div class="waitselect" style="width: 230px;display:flex;">
                            <span>订单编号：</span>
                            <input type="text"   v-model="waiterOrderQueryObj.orderSn" />
                        </div> 
                        <div class="waitselect" style="width: 230px;display:flex;">
                            <span>订单状态：</span>
                            <Select v-model="waiterOrderQueryObj.state" class="bmselect"  :datas="stateList"></Select>
                        </div>
                        <div class="waitselect" style="width: 230px;display:flex;">
                            <span>订单状态：</span>
                            <Select v-model="waiterOrderQueryObj.waiterState" class="bmselect"  :datas="waiterStateList"></Select>
                        </div>
                        <div class="waitselect"><button class="h-btn h-btn-blue" @click="waiterOrderListQuery">查询</button> </div>
                    </div> 
                </div>
                <div class="dv_waiter_tally">
                    总订单数：{{tally.orderCnt }}&nbsp;&nbsp;订单总金额：{{tally.orderAmount }}&nbsp;&nbsp;服务人员总佣金：{{tally.rebateAmount }}&nbsp;&nbsp;可提现余额：{{tally.cashOutAmount }}
                </div>
                <div class="tablessbox"> 
				<table class="tableorderlist">
					<tr class="headtr">					
						<td style="text-align:center;">订单编号</td>
                        <td style="text-align:center;">定金</td>
						<td style="text-align:center;">店铺名称</td>
						<td style="text-align:center;">店铺地址</td>
						<td style="text-align:center;">订单金额</td>
						<td style="text-align:center;">服务类型</td>
						<td style="text-align:center;">用户信息</td>
						<td style="text-align:center;">订单状态</td>
						<td style="text-align:center;">佣金</td>
						<td style="text-align:center;">订单备注</td> 
						
					</tr>
					<tbody v-if="orderrecord.length>0">
					<tr v-for="(item,index) in orderrecord" :key="index">
						<td style="width:100px;text-align:center;"><span>{{item.orderSn}}</span></td>
                        <td style="width:80px;text-align:center;"><span>-</span></td>
						<td style="width:90px;text-align:center;"><span>{{item.storeName}}</span></td>
						<td style="width:150px;text-align:center;"><span>{{item.storeAddress}}</span></td>
						<td style="width:80px;text-align:center;"><span>{{item.orderAmount}}</span></td>
						<td style="width:80px;text-align:center;">
                            {{item.orderType==1 ? '商城': item.orderType==2 ? '外卖' : item.orderType==3 ? '团购' : item.orderType==4 ? '生鲜' : item.orderType==5 ? '品牌' 
							: item.orderType==6 ? '医药' : item.orderType==7 ? '食疗' : item.orderType==8 ? '生活服务' : item.orderType==9 ? '优惠买单' : item.orderType==10 ? '房产' :
							 item.orderType==11 ? '汽车' : item.orderType==12 ? '成家立业' : item.orderType==13 ? '店内收银' : ''}}
                        </td>
						<td style="width:200px;text-align:center;">
                            <span>用户名：{{item.buyerName}}</span></br>
                            <span>用户手机号：{{item.buyerPhone}}</span>
                        </td>
						<td style="text-align:center;width:200px;">
                           <span style="color:blue;" v-if="item.state==1">已支付</span>
                           <span style="color:green;" v-if="item.state==2">已完成</span>
                           <span style="color:red;" v-if="item.state==3">交易关闭</span>&nbsp;|&nbsp;
                           <span style="color:green;" v-if="item.waiterState==1">已服务</span>
                           <span style="color:red;" v-if="item.waiterState==2">未服务</span>
                           </br>
                           <span>下单时间：{{item.orderTime}}</span></br>
                           <span>支付时间：{{item.payTime}}</span></br>
                           <span>订单类型：商家</span>
                        </td>
						<td style="width:60px;text-align:center;"><span>{{item.rebateAmount}}</span></td>
						<td style="width:100px;text-align:center;"><span>-</span></td>
					</tr>
				</tbody>	
					<tr v-else>
						<td colSpan="11" style="text-align:center;padding-top:80px;padding-bottom:100px;border:none;">没有数据！</td>
					</tr>	
				</table> 

				<div class="yema" v-show="orderrecord.length>0">
					<a-pagination
						v-model="current"
						:total="total"
						:page-size="pageSize" >
						<template slot="buildOptionText" slot-scope="props">
						<span v-if="props.value !== '50'">{{ props.value }}条/页</span>
						<span v-if="props.value === '50'">全部</span>
						</template>
					</a-pagination>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>

import moment from 'moment';
import { mapState } from 'vuex';
import 'moment/locale/zh-cn';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
export default {
	name: "Salarymanage",
	data() {
		return {
			dataList: {},
			select: 0,
            waiterList:[],
            waiterList2:[],
            storeSelect:0,
            orderrecord:[],
            showOrder:false,
			confirmLoading:false,
			param: [{ title: '全部', key: 0 }, { title: '选择1', key: 1 }, { title: '选择2', key: 2 }],
            stateList:[
                { title: '全部', key: 0 },
                { title: '已付款', key: 1 },
                { title: '已收货', key: 2 },
                { title: '取消', key: 3 }
                ],
            waiterStateList:[
                { title: '全部', key: 0 },
                { title: '已服务', key: 1 },
                { title: '未服务', key: 2 } 
                ],
			waiterSelect:0,
            storeSelect:0,
            waiterOrderQueryObj:{
                waiterOrderSelect:0,
                waiterId:0,
                orderSn:'',
                state:0,
                waiterState:0,
                startTime: undefined,
                endTime:undefined
            },
            tally:{
                orderCnt:0,
                orderAmount:0,
                rebateAmount:0,
                cashOutAmount:0
            },
            locale,
            storeList:[],
            waiterList:[],
			datas: [],
			size: 10,
			pagination: {
				page: 1,
				size: 10,
				total: 100
			},
			visible: false,       
			defauldepartment: '',
			departmentlist: [],
			defaulfiveone: false,
			defaulstate: '1',
			defaulsex: "男",
			clickstyle: 'new', 
            current: 1, //页码
			pageSize: 10,
			total: 50
		}
	},
	computed: {
		...mapState(['User', 'currentAccountSets']),
	},
	methods: {

	

		//列表查询
		getstafflist() {
  
			var accountSetsId = this.User.accountSetsId;
			var parmas = {
				accountSetsId, 
				waiterId: this.waiterSelect,
				storeId: this.storeSelect
			}
            var waiterArry = [{ title: '全部', key: 0 }];
            var waiterArry2 = [];
            this.waiterList = waiterArry;
            this.waiterList2 = waiterArry2;
			this.$api.community.waiterQueryList(parmas).then(data => {
				console.log('data', data);

				if (data.code == 200) { 
					this.datas = data.data;
                    this.datas.forEach(e => {
						var item = {};
						item.title = e.name;
						item.key = e.waiterId; 
						waiterArry.push(item);
                        waiterArry2.push(item);
					});
				}
                if(this.waiterList==undefined || this.waiterList.length==1){
                    this.waiterList = waiterArry;
                    this.waiterList2 = waiterArry2;
                }
			})

		},
		//店铺列表
		getStoreList() {
			var accountSetsId = this.User.accountSetsId;
			this.$api.community.getStoreList(accountSetsId).then(res => {
				if (res.code == 200) {
                    var newarr = [{ title: '全部', key: 0 }];
                     
					res.data.forEach(e => {
						var arrlist = {};
						arrlist.title = e.name;
						arrlist.key = e.id; 
						newarr.push(arrlist);
					});

					this.storeList = newarr;

				}
			})

		}, 
        waiterOrderList(waiterId){
            var that = this;
            var parmas = this.waiterOrderQueryObj;
            parmas.waiterId = waiterId;
            parmas.current = 1;
            parmas.size = 10;
            console.log('aaa');
            console.log(parmas);
            console.log('bbb');
            this.$api.community.waiterOrderQueryList(parmas).then(res => {
                console.log(res);
				if (res.code == 200) {
                    that.orderrecord=res.data.records;
                    that.current = res.data.current;
					that.total = res.data.pages;
				}
			})
        },
        showDrawer(data){
            console.log(data);
            this.showOrder = true;
            this.waiterOrderQueryObj.waiterOrderSelect=data.waiterId;
            this.$nextTick(() => {
                this.$forceUpdate()
            })
            this.waiterOrderList(data.waiterId);
            this.orderTally(data.waiterId);
        },
        orderTally(waiterId){
            this.$api.community.getOrderTally(waiterId).then(res => {
				if (res.code == 200) {
                    this.tally=res.data;  
				}
			})
        },
        waiterOrderListQuery(){
            this.waiterOrderList(this.waiterOrderQueryObj.waiterOrderSelect);
        },
        selectStore(e){
            console.log(e)
            console.log(this.storeSelect)
        }, 
		selectWaiter(e) {  
            
		},
        selectWaiter2(e) {  
            // console.log(e);
            this.waiterOrderList(e.key);
		},
		onClose() {
			this.visible = false;
		},
  
		selectmsg(e) { 
			this.getstafflist() 
		},
        onLocalChange(date, dateString) {
			this.waiterOrderQueryObj.startTime = dateString[0];
			this.waiterOrderQueryObj.endTime = dateString[1];
			this.size = '';  
		},


	},
	mounted() {
        // console.log(this.User);
		this.getstafflist();
		this.getStoreList();
	}
}
</script>


<style lang="less" scoped>
.md_showOrder{
    width:1500px;
    height:650px;
}
.h-row>div>div {
	padding: 8px;
	border-radius: 5px;
	text-align: center;
	font-size: 20px;
	color: #000;
}

.period {
	border-radius: 3px;
	text-align: center;
	line-height: 54px;
	border: 1px solid @primary-color;
	white-space: nowrap;
	overflow: hidden;
	box-sizing: border-box;
	height: 80px;

	&:hover {
		cursor: pointer;
		box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
	}

	.month-header {
		height: 25px;
		margin: -8px -8px 0 -8px;
	}

	&.completed {
		.month-header {
			background-color: @gray1-color !important;
			line-height: 20px;
		}

		border-color: @gray1-color;

		color: #a2a2a2;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}

	&.disable {
		opacity: 0.4;

		&:hover {
			cursor: default;
			box-shadow: none;
		}
	}


}

.dv_waiter_tally{
    margin-top:10px;
    margin-left: 20px;
    margin-right:72px;
    padding-left:20px;
    padding-top:5px;
    padding-bottom:5px;
    font-weight: bold;
    background-color:powderblue;
    line-height: 25px;;
    
    border-radius: 20px;
}
.topselectbox {
	padding-top: 10px;
	padding-left: 10px;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.topselectbox .waitselect {
	float: left;
	padding-left: 10px;
	padding-top: 10px;
	display: flex;
	justify-content: left;
	align-items: center;
	font-weight: normal;
}
.topselectbox .waitselect2 {
	float: left;
	padding-left: 10px;
	padding-top: 10px;
	display: flex;
	justify-content: left;
	align-items: center;
	font-weight: normal;
}
.topselectbox .waitselect span {
    width:100px;
    margin-left:5;
}

.topselectbox .waitselect .bmselect {
	width: 160px;
}

.topselectbox .depselect02 {
	padding-top: 10px;
	float: left;
	display: flex;
	justify-content: left;
	align-items: center;
}
 
.emtablebox {
	padding-top: 20px;
	padding-left: 18px;
	min-height: 650px;
}

.emtablebox tbody {}

.emtablebox table tbody tr td {
	font-weight: normal !important;
	;
}

.yemabox {
	padding-top: 50px;
	padding-bottom: 30px;
}


.ziliaotable {}

.ziliaotable table {
	width: 100%
}

.ziliaotable table tr {
	width: 100%;
	display: flex;
	justify-content: left;
	align-items: center;
}

.ziliaotable table tr td {
	display: flex;
	padding-top: 10px;
	padding-bottom: 10px;
	justify-content: right;
	align-items: center;
	width: 100%;
}

.fiveonebox {
	padding-top: 20px;
	padding-bottom: 100px;
}

.fiveonebox h3 {
	padding-top: 20px;
	padding-bottom: 10px;
}

.datagridbox {
	padding-top: 20px;
}

.datagrid-htable {
	width: 100%;
}

.datagrid-htable tr td {
	border: 1px solid #ddd;
	text-align: center;
	padding-top: 10px;
	padding-bottom: 10px;
	vertical-align: middle;
}

.datagrid-htable tr.datagrid-header-row td {
	border: 1px solid #ddd;
	text-align: center;
	background: #f2f2f2;
}

.datagrid-htable tr td div {
	text-align: center;
}

.datagrid-htable .tbody02 {}

.datagrid-htable .tbody02 tr td {
	vertical-align: middle !important;
}

.datagrid-htable .tbody02 tr td span {
	padding-left: 5px;
	padding-top: 10px;
}

.newdecreat {}

.newdecreat li {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
}

.tableorderlist{ width:1300px;font-weight:none!important;}
.tableorderlist tr {font-weight:none!important;}
.tableorderlist tr td{  font-weight:normal; padding:20px 5px; border-bottom:1px solid #eee;}

.tableorderlist .headtr td{  font-weight:bold;}

 
.tablessbox{ min-height:300px;}


.tableorderlist tr td dl.rmdl{ float:left; padding-right:20px;}
.tableorderlist tr td dl.rmdl dt{ color:#1E5AEE; font-weight:bold;}
.yema{ text-align:center; padding-top:30px;}
</style>
